import {connect} from 'react-redux'
import AddEditOrderDialog from "../../Components/Orders/EditOrderDialog/AddEditOrderDialog";
import * as deliveryGroupActions from "../actions/deliveryGroupsActions";
import * as messengersActions from "../actions/messengersActions";
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";
import * as logActions from "../actions/logActions";

const mapStateToProps = (store) => {
    return {
        scheduledSlaBefore: store.businessReducer.business.scheduledSlaBefore,
        scheduledSlaAfter: store.businessReducer.business.scheduledSlaAfter,
        sla: store.businessReducer.business.sla,
        minAddressChangeRecommendationFly: store.businessReducer.business.minAddressChangeRecommendationFly,
        isAreaSlaEnabled: store.businessReducer.business.isAreaSlaEnabled,
        isOrcaSendingEnabled: store.businessReducer.business.isOrcaSendingEnabled,
        urgentSla: store.businessReducer.business.urgentSla,
        isAutopilot: store.businessReducer.business.isAutopilot
    };
};

const mapDispatchToProps = {
    logInfo: logActions.logInfoAction
};

const AddEditOrderDialogContainer = connect(mapStateToProps, mapDispatchToProps)(AddEditOrderDialog);

export default AddEditOrderDialogContainer;